var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';

import { Dropdown } from "../Dropdown/";
import { ButtonSetting } from '../Button/';
import ButtongroupOptions from './ButtongroupOptions';

import './ButtongroupSettings.scss';

var ButtongroupSettings = (_temp2 = _class = function (_Component) {
    _inherits(ButtongroupSettings, _Component);

    function ButtongroupSettings() {
        var _temp, _this, _ret;

        _classCallCheck(this, ButtongroupSettings);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = _this.props, _this.onToggle = function () {
            _this.setState(function (prevState) {
                return {
                    expanded: !prevState.expanded
                };
            });
        }, _this.getSelected = function () {
            var _this$props = _this.props,
                value = _this$props.value,
                options = _this$props.options;

            var selected = options.find(function (option) {
                return option.value === value;
            });

            if (!selected) {
                selected = options[0];
            }

            return selected;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    ButtongroupSettings.prototype.render = function render() {
        var _state = this.state,
            name = _state.name,
            expanded = _state.expanded;

        var selected = this.getSelected();

        return React.createElement(
            'div',
            { className: 'admin-buttongroup  admin-buttongroup--settings', role: 'option', 'aria-selected': selected },
            React.createElement(ButtonSetting, { name: name, label: selected.title, icon: selected.icon, expanded: expanded, onClick: this.onToggle }),
            React.createElement(
                Dropdown,
                { type: 'settings', expanded: expanded },
                React.createElement(ButtongroupOptions, this.props)
            )
        );
    };

    return ButtongroupSettings;
}(Component), _class.defaultProps = {
    name: "settings",
    expanded: false
}, _temp2);


export default ButtongroupSettings;